import React from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE,
  AFFILIATED_LEAD_GENERATED_MODULE_ROUTE,
  AFFILIATED_MESSAGE_MODULE_ROUTE,
  AFFILIATED_ROUTE_PREFIX,
} from '../../routes/routes';

const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { height: 224, paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  if (
    pathName === AFFILIATED_ROUTE_PREFIX.slice(0, -1) &&
    routeName === AFFILIATED_LEAD_GENERATED_MODULE_ROUTE
  )
    return true;
  else if (pathName !== AFFILIATED_ROUTE_PREFIX.slice(0, -1)) {
    return pathName.includes(routeName);
  }
};

const SideNavBar = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();

  const paths = [
    {
      name: 'Generated Leads',
      link: AFFILIATED_LEAD_GENERATED_MODULE_ROUTE,
    },
    {
      name: 'Converted Leads',
      link: AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE,
    },
    {
      name: 'Help & Support',
      link: AFFILIATED_MESSAGE_MODULE_ROUTE,
    },
  ];

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {paths.map((path) => {
        const isActive = isActiveRoute(path.link, pathname);
        return (
          <Link
            key={path.name}
            to={path.link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })}
    </Box>
  );
};

export default SideNavBar;
